import { render, staticRenderFns } from "./app-content-items.vue?vue&type=template&id=463539a2&"
import script from "./app-content-items.vue?vue&type=script&lang=js&"
export * from "./app-content-items.vue?vue&type=script&lang=js&"
import style0 from "./app-content-items.vue?vue&type=style&index=0&id=463539a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports